import {scale} from "../../utils";
import theme, {FONTS} from "../../constants/theme";
import Text from "../text";
import Base from "../base";
import {SxProps} from "@mui/material";
import {useMediaQuery} from "@mui/system";

interface Props {
  dayName: string;
  dayNumber: string;
  month: string;
  year: string;
  colorStyle: 'primary' | 'secondary';
  sx?: SxProps;
}


const DateCard = ({dayName, dayNumber, month, year, colorStyle, sx}: Props) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Base
      style={{
        width: scale(230),
        minHeight: isMobile ? scale(200) : undefined,
        height: isMobile ? scale(200) : scale(230),
        backgroundColor: colorStyle === 'primary' ? theme.palette.primary.main : theme.palette.white.main,
        justifyContent: 'center',
        borderRadius: scale(18),
      }}
      sx={{

        ...sx
      }}
    >
      <Text
        text={dayName}
        fontFamily={FONTS.MONTSERRAT}
        color={colorStyle === 'primary' ? theme.palette.text.primary : theme.palette.text.secondary}
        fontSize={scale(20)}
        fontWeight={'bold'}
        sx={{ textTransform: 'uppercase' }}
      />
      <Text
        text={dayNumber}
        fontFamily={FONTS.MONTSERRAT}
        color={colorStyle === 'primary' ? theme.palette.text.primary : theme.palette.text.secondary}
        fontSize={scale(82)}
        fontWeight={'bold'}
        lineHeight={scale(90)}
        sx={{ textTransform: 'uppercase' }}
      />
      <Text
        text={month.concat(' ').concat(year)}
        fontFamily={FONTS.MONTSERRAT}
        color={colorStyle === 'primary' ? theme.palette.text.primary : theme.palette.text.secondary}
        fontSize={scale(32)}
        fontWeight={'bold'}
        lineHeight={scale(39)}
        sx={{ textTransform: 'uppercase', textAlign: 'center' }}
      />
    </Base>
  )
}

export default DateCard;
